import React from 'react';
import { X } from 'lucide-react';
import { DateFilter } from '../types';

interface DateFilterProps {
  dateFilter: DateFilter;
  onDateFilterChange: (filter: DateFilter) => void;
  className?: string;
}

const DateFilterComponent: React.FC<DateFilterProps> = ({
  dateFilter,
  onDateFilterChange,
  className = ''
}) => {
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value ? new Date(e.target.value) : null;
    onDateFilterChange({ ...dateFilter, startDate: date });
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value ? new Date(e.target.value) : null;
    onDateFilterChange({ ...dateFilter, endDate: date });
  };

  const clearFilters = () => {
    onDateFilterChange({ startDate: null, endDate: null });
  };

  const formatDateForInput = (date: Date | null) => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };

  return (
    <div className={className}>
      <div className="flex justify-end">
        {(dateFilter.startDate || dateFilter.endDate) && (
          <button
            onClick={clearFilters}
            className="text-xs font-semibold text-slate-500 hover:text-red-600 flex items-center transition-colors bg-slate-100 hover:bg-red-50 px-2 py-1 rounded-md mb-2"
          >
            <X className="h-4 w-4 mr-1" />
            Clear
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">
            Start Date
          </label>
          <input
            type="date"
            value={formatDateForInput(dateFilter.startDate)}
            onChange={handleStartDateChange}
            className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all font-medium text-slate-700"
          />
        </div>

        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">
            End Date
          </label>
          <input
            type="date"
            value={formatDateForInput(dateFilter.endDate)}
            onChange={handleEndDateChange}
            min={formatDateForInput(dateFilter.startDate)}
            className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all font-medium text-slate-700"
          />
        </div>
      </div>

      {dateFilter.startDate && dateFilter.endDate && (
        <div className="mt-4 p-3 bg-emerald-50 border border-emerald-100 rounded-lg">
          <p className="text-xs font-medium text-emerald-800 flex items-center">
            Filtering from {dateFilter.startDate.toLocaleDateString('en-US')} to {dateFilter.endDate.toLocaleDateString('en-US')}
          </p>
        </div>
      )}
    </div>
  );
};

export default DateFilterComponent;
